import React from 'react';
import NewsletterSubscribe from '../newsletter/NewsletterSubscribe';

const NewsletterCTA: React.FC = () => {
  return (
    <section className="newsletter-cta" style={{ marginTop: 24, marginBottom: 24 }}>
      <div className="card" style={{ maxWidth: 960, margin: '0 auto' }}>
        <NewsletterSubscribe />
      </div>
    </section>
  );
};

export default NewsletterCTA;
